<template>
  <div style="position: relative; width: 100%">
    <div
      class="elevation-8 included-in-acorn-trait-search-bar traits-menu"
      v-if="showTraitsMenu"
      v-click-outside="{
        handler: onClickOutside,
        include: includeOnClickOutside,
      }"
    >
      <v-container v-if="searchValue === ''" class="full-width">
        <v-row>
          <!-- Theme -->
          <v-col :cols="2" style="height: 60vh; overflow: auto">
            <v-list nav dense>
              <v-list-item-group v-model="selectedThemeIndex">
                <v-list-item v-for="item in traitsAsTree" :key="item[0]">
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <!-- Subject -->
          <v-col
            v-if="selectedThemeIndex >= 0"
            cols="4"
            style="height: 60vh; overflow: auto"
          >
            <v-list nav dense>
              <v-list-item-group v-model="selectedSubjectIndex">
                <v-list-item
                  v-for="item in traitsAsTree[selectedThemeIndex][1]"
                  :key="item[0]"
                >
                  <v-list-item-title v-text="item[0]"></v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <!-- Variable -->
          <v-col
            v-if="selectedSubjectIndex >= 0"
            cols="6"
            style="height: 60vh; overflow: auto"
          >
            <div class="v-list v-sheet v-list--dense v-list--nav">
              <v-list-item-group multiple v-model="selectedTraits">
                <template
                  v-for="(item, i) in traitsAsTree[selectedThemeIndex][1][
                    selectedSubjectIndex
                  ][1]"
                >
                  <v-list-item :key="`item-${i}-${item[1]}`" :value="item[1]">
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title v-text="getCvcVariableText(...item)"/>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else-if="searchValue.length < 3"
        >Type more than 2 characters to filter results...</v-container
      >
      <v-container v-else-if="filteredTraits.length === 0"
        >No results found</v-container
      >
      <v-container v-else>
        <v-list>
          <v-list-item
            v-for="(trait, i) in filteredTraits"
            :key="i"
            @click="() => selectTrait(trait[0])"
            >{{ trait[1] }}</v-list-item
          >
        </v-list>
      </v-container>
    </div>
    <v-btn
      class="included-in-acorn-trait-search-bar search-button"
      @click="
        () => {
          this.showTraitsMenu = true;
        }
      "
    >
      Traits
    </v-btn>
    <!-- <v-autocomplete
      :items="myitems"
      v-model="selectedTraits"
      chips
      clearable
      deletable-chips
      multiple
    ></v-autocomplete> -->
  </div>
</template>

<script>
import traits from "@/assets/traits.json";
import traitsAsTree from "@/assets/traits_as_tree.json";
import covaticVariableTextMapper from "@/assets/covatic_variable_text_mapper.json";

const indexedTraits = traits.map((v, i) => [i, v]);

export default {
  name: "CvcAcornTraitSearch",
  props: ["value"],
  data() {
    return {
      searchValue: "",
      traits,
      indexedTraits,
      traitsAsTree,
      selectedThemeIndex: -1,
      selectedSubjectIndex: -1,
      selectedVariableIndex: -1,
      selectedTraits: [],
      showTraitsMenu: false,
      myitems: traits.map((x) => ({ text: x, value: x })),
    };
  },
  mounted() {
    window.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        this.onClickOutside()
      }
    });
  },

  computed: {
    filteredTraits() {
      // TODO make more efficient
      const searchValueLower = this.searchValue.toLowerCase();
      return indexedTraits.filter((x) =>
        x[1].toLowerCase().includes(searchValueLower)
      );
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedTraits = newVal;
      },
      immediate: true,
    },
    selectedTraits() {
      this.$emit("input", this.selectedTraits);
    },
    selectedThemeIndex() {
      this.selectedSubjectIndex = -1;
      this.selectedVariableIndex = -1;
    },
    selectedSubjectIndex() {
      this.selectedVariableIndex = -1;
    },
    selectedVariableIndex() {
      if (this.selectedVariableIndex !== -1) {
        this.selectedTraits.push(
          this.getVariableIndex(
            this.selectedThemeIndex,
            this.selectedSubjectIndex,
            this.selectedVariableIndex
          )
        );

        this.selectedSubjectIndex = -1;
        this.selectedThemeIndex = -1;
        this.selectedVariableIndex = -1;

        this.showTraitsMenu = false;
      }
    },
  },
  methods: {
    somethingChangedInFancyMenu(...args) {
      console.log(args)
    },
    onClickOutside() {
      this.showTraitsMenu = false;
    },
    includeOnClickOutside() {
      let newArray = [];
      this.$el
        .querySelectorAll(".included-in-acorn-trait-search-bar")
        .forEach((i) => newArray.push(i));
      return newArray;
    },
    getCvcVariableText(acornVariableText, variableIndex) {
      return covaticVariableTextMapper[variableIndex.toString()] ?? acornVariableText;
    },
    getVariableIndex(themeIndex, subjectIndex, variableIndex) {
      // OK, the names of these variables confuse me (and I made them), but I
      // know this code works. TODO document this properly.
      return this.traitsAsTree[themeIndex][1][subjectIndex][1][
        variableIndex
      ][1];
    },
    selectTrait(i) {
      this.selectedTraits.push(i);
      this.searchValue = "";
      this.showTraitsMenu = false;
    },
    clickOnMenu(e) {
      // Do something with the menu
      // Put the focus right back on the text bar in case they want to search
      console.log(e);
      this.selectedTheme = e.target.innerHTML;
      document.getElementById("cvc-acorn-trait-search-bar").focus();
    },
    onFocus(e) {
      this.initialMenuVisible = true;
    },
    onBlur(e) {
      //   this.initialMenuVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-column {
  overflow: scroll;
  background: red;
  display: flex;
}
.search-button {
  line-height: 44px;
  color: white !important;
  width: 270px;
  height: 44px !important;
  display: block;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  text-transform: none;
  font-size: 18px;
  font-weight: normal;
}
.traits-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 600%;
  height: 60vh;
  background: white;
  z-index: 8;
}
</style>
